// Zentraler App-Name & Persistenz-Key.
//
// APP_NAME ist ein ARBEITSTITEL bis zur Markenprüfung (siehe ../../docs/naming-shortlist.md).
// Hier an genau einer Stelle ändern — niemals im Code verteilen. Kein finaler Markenname.
// Kandidaten aus dem Naming-Sprint: "Lexora", "Patent Trainer" (erst nach Verwechslungs-,
// Marken- und Domaincheck festlegen).
export const APP_NAME = "Examenstrainer";
export const APP_STAGE = "Private Beta";
export const APP_MARK = "EX"; // Kürzel für die Sidebar-Marke

// Persistenz-Key, bewusst vom Marketing-Namen entkoppelt (Namenswechsel verliert keinen Fortschritt).
export const STORAGE_KEY = "learning-app-state-v1";

// Admin-Build (VITE_ADMIN=true). Normale Beta-Nutzer sehen nur Trainieren, Übersicht
// und "Fehler melden"; Import, Beta-Gate und Bibliothek bleiben Admins vorbehalten.
export const IS_ADMIN = import.meta.env.VITE_ADMIN === "true";
